// 组件
import { AliveScope } from 'react-activation';
import { Routers } from '@/components';
// 常量
import router from "@/configs/routers";

const Index = () => {
  return (
    <AliveScope>
      <Routers items={router} />
    </AliveScope>
  );
};

export default Index;
